import { render, staticRenderFns } from "./ResultExportCard.vue?vue&type=template&id=32494335"
import script from "./ResultExportCard.vue?vue&type=script&lang=js"
export * from "./ResultExportCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports